import i18next from 'i18next'

i18next.addResourceBundle('en', 'groups', {
    confirm_deletion: 'Are you sure you want to delete this group?',
    confirm_deletion_title: 'Confirm Deletion',
    table: {
        name: 'Name',
        description: 'Description',
        members: 'Members',
        actions: 'Actions',
    },
    apply: 'Apply',
    search_placeholder: 'Search by name',
    invite_group: 'Invite Group',
    cancel: 'Cancel',
    invite: 'Invite',
    role: {
        VIEWER: 'Viewer',
        CONTRIBUTOR: 'Contributor',
        MANAGER: 'Manager'
    },
    details: 'Details',
    design_repositories: 'Design Repositories',
    deploy_repositories: 'Deploy Repositories',
    projects: 'Projects',
    description: 'Description',
    name: 'Name',
    admin: 'Admin',
    name_required: 'Name is required',
    group_name_max_length: 'Group name must be at most 65 characters long',
    description_max_length: 'Description must be at most 200 characters long',
    edit_group: 'Edit Group',
    failed_to_load_groups: 'Failed to load groups. Please try again.',
    failed_to_load_members: 'Failed to load the group members. Please try again.',
    no_members: 'No members',
    retry: 'Retry',
})
